module.exports = __webpack_public_path__ + "static/media/apple-pay.b1070d94.svg";